class CollectionFiltersToggle extends HTMLElement {
  constructor() {
    super();
    this.filterToggle = null;
    this.advancedFilters = null;
    this.filtersDrawer = null;
    this.filtersBackdrop = null;
    this.drawerClose = null;
  }
  connectedCallback() {
    this.filterToggle = document.getElementById("FilterToggle");
    this.advancedFilters = document.querySelector(".advanced-filters");
    this.filtersDrawer = document.querySelector(".filters-drawer");
    this.filtersBackdrop = document.querySelector(".filters-backdrop");
    this.drawerClose = document.querySelector(".filters-drawer-close");
    this.init();
  }
  disconnectedCallback() {
    if (this.filterToggle) {
      this.filterToggle.removeEventListener("click", this.handleToggleClick);
    }
    if (this.drawerClose) {
      this.drawerClose.removeEventListener("click", this.handleCloseDrawer);
    }
    if (this.filtersBackdrop) {
      this.filtersBackdrop.removeEventListener("click", this.handleCloseDrawer);
    }
    document.removeEventListener("keydown", this.handleEscapeKey);
  }
  init() {
    if (!this.filterToggle || !this.advancedFilters) return;
    const filtersVisible = localStorage.getItem("filters-visible") === "true";
    if (filtersVisible) {
      this.advancedFilters.classList.remove("hidden");
      this.filterToggle.classList.add("active");
    } else {
      this.filterToggle.classList.remove("active");
    }
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handleCloseDrawer = this.handleCloseDrawer.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.filterToggle.addEventListener("click", this.handleToggleClick);
    if (this.drawerClose) {
      this.drawerClose.addEventListener("click", this.handleCloseDrawer);
    }
    if (this.filtersBackdrop) {
      this.filtersBackdrop.addEventListener("click", this.handleCloseDrawer);
    }
    document.addEventListener("keydown", this.handleEscapeKey);
  }
  handleToggleClick() {
    const isMobile = window.innerWidth < 1024;
    if (isMobile) {
      this.updateHeaderHeight();
      if (this.filtersDrawer) {
        this.filtersDrawer.classList.add("active");
      }
      if (this.filtersBackdrop) {
        this.filtersBackdrop.classList.add("active");
      }
      document.body.classList.add("filters-drawer-open");
    } else {
      const isCurrentlyHidden = this.advancedFilters.classList.contains("hidden");
      if (isCurrentlyHidden) {
        this.advancedFilters.classList.remove("hidden");
        this.filterToggle.classList.add("active");
        localStorage.setItem("filters-visible", "true");
      } else {
        this.advancedFilters.classList.add("hidden");
        this.filterToggle.classList.remove("active");
        localStorage.setItem("filters-visible", "false");
      }
    }
  }
  handleCloseDrawer() {
    if (this.filtersDrawer) {
      this.filtersDrawer.classList.remove("active");
    }
    if (this.filtersBackdrop) {
      this.filtersBackdrop.classList.remove("active");
    }
    document.body.classList.remove("filters-drawer-open");
  }
  handleEscapeKey(e) {
    if (e.key === "Escape" && this.filtersDrawer && this.filtersDrawer.classList.contains("active")) {
      this.handleCloseDrawer();
    }
  }
  updateHeaderHeight() {
    const header = document.querySelector("#shopify-section-header");
    if (header) {
      document.documentElement.style.setProperty("--height-nav", `${header.offsetHeight}px`);
    }
  }
}
if (!customElements.get("collection-filters-toggle")) {
  customElements.define("collection-filters-toggle", CollectionFiltersToggle);
}
